import { fromJS, List, Map } from 'immutable';
// import { } from './../Record/DestinationCollection';
const NAME_SPACE = 'DC/';
const initialState = Map({
  'loading': true,
  'data': List([]),
  'pageSize': 0,
  'currentPage': 0,
  'count': 0,
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_DESTINATION_COLLECTION':
      return fromJS(action.payload.DestinationCollection);
    default:
      return state;
  }
};

const Destination = (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_DESTINATION_COLLECTION':
      return item(state, action);
    default:
      return state;
  }
};

export default Destination;